import { useState, useEffect } from "react";

// Custom hook to check for mobile device with debounced resize handling
const useIsMobile = (maxMobileWidth = 900) => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return undefined; // SSR-safe
    return window.innerWidth <= maxMobileWidth ;
  });

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= maxMobileWidth);
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, [maxMobileWidth]);

  return isMobile;
};

// Hook to get window size efficiently
export function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== "undefined" ? window.innerWidth : undefined,
    height: typeof window !== "undefined" ? window.innerHeight : undefined,
  });

  useEffect(() => {
    let timeoutId;
    
    const handleResize = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }, 200); // Debounce to reduce excessive updates
    };

    window.addEventListener("resize", handleResize);
    
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return windowSize;
}

export default useIsMobile;

